export const environment = {
  "production": false,
  "apiEndPoint": "https://84.228.29.126:7101",
  "appVersion": "1.0"
};
